import React, { useContext, useEffect } from 'react';
import {
  Row, Select, Typography, Spin,
} from 'antd';
import { connect } from 'react-redux';
import './Locales.css';
import ReactCountryFlag from 'react-country-flag';
import { ViaLocaleContext } from '../../contexts/ViaLanguageProvider';
import { selectAppConfig } from '../../state/domain/appConfig/appConfigReducer';
import { requestSupportedLanguages } from '../../state/ui/application/sessionUiActions';

const { Option } = Select;

/**
 * Bynx Selector to select the locale language
 * @constructor
 */
function LocaleSelector({ languages, getAvailiableLanguages, }) {
  const { appLocale, toggleLocale } = useContext(ViaLocaleContext);

  useEffect(() => { if (!languages) getAvailiableLanguages(); }, [languages, getAvailiableLanguages]);
  return (
    <Select size="default" defaultValue={appLocale.code} style={{ width: '250px' }} onChange={toggleLocale}>
      { languages ? languages.map(language => (
        <Option key={language.languageCode} value={language.languageCode}>
          <Row type="flex" align="middle">
            <ReactCountryFlag code={language.languageCode.slice(language.languageCode.indexOf('_') + 1, language.languageCode.length).toLowerCase()} svg />
            <Typography.Text>
              &nbsp;
              {language.languageDescription}
            </Typography.Text>
          </Row>
        </Option>
      )) : <Option key="spin" value="spin"><Spin /></Option>
      }
    </Select>
  );
}

/**
 * A function for connecting redux state to the component props.
 */
const mapStateToProps = (state) => {
  return {
    languages: selectAppConfig(state, 'languages') ? selectAppConfig(state, 'languages').languages : null,
  };
};

/**
 * A function for connecting redux action to the component props.
 */
const mapDispatchToProps = dispatch => ({
  getAvailiableLanguages: () => dispatch(requestSupportedLanguages()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocaleSelector);
